import SearchResultPage from '@atlassian/mpac-search/search-result-page';
import { useHistory } from '@atlassian/mpac-ui';
import React from 'react';
import { Redirect } from 'react-router-dom';

import type { RouteComponentProps } from 'react-router-dom';

const searchResultPageRedirectionMap = {
  betaVersion: 'other=stable',
  vendorSupported: 'other=vendorSupported',
  free: 'price=paid',
  freeStarterTier: 'price=freeStarterTier',
} as const;

const AddonSearchResultPageRouteProcessor = (props: RouteComponentProps) => {
  const {
    location: { pathname, search },
  } = props;
  const history = useHistory();
  const params = new URLSearchParams(search);
  const moreFilters = params.get('moreFilters');
  const category = params.get('category');

  if (category) {
    params.set('useCases', category);
    params.delete('category');
    history?.push(`${pathname}?${params}`);
  }

  if (moreFilters && searchResultPageRedirectionMap[moreFilters]) {
    params.delete('moreFilters');
    return <Redirect to={`/search?${params}&${searchResultPageRedirectionMap[moreFilters]}`} />;
  }

  return <SearchResultPage />;
};

export default AddonSearchResultPageRouteProcessor;
